// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__21T0S","name":"ConsentHeader_name__3kmqc","birthday":"ConsentHeader_birthday__o_xdB","skeleton":"ConsentHeader_skeleton__3CncV"};